import { render, staticRenderFns } from "./Peaje.vue?vue&type=template&id=f37883f8&"
import script from "./Peaje.vue?vue&type=script&lang=js&"
export * from "./Peaje.vue?vue&type=script&lang=js&"
import style0 from "./Peaje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports